import React from 'react';
import { getThumbnailUrls } from '../../utils/getThumbnailUrls/getThumbnailUrls';
import styles from './Image.scss';

export const Image = ({
  url = '',
  label = '',
  width,
  height,
}: {
  url: string;
  label: string;
  width: number;
  height?: number;
}) => {
  if (!url) return null;

  const thumbnailData = getThumbnailUrls(url, width, height);

  return (
    <img
      className={styles.image}
      src={thumbnailData.src}
      srcSet={thumbnailData.srcset}
      alt="" // Deliberately empty alt text as these are decorative images
      width={'100%'}
      height={'100%'}
      data-testid={`nav-thumbnail-${label.toLowerCase().replace(/\s+/g, '-')}`}
    />
  );
};
